import Vue from 'vue'
import { getDateString } from '@/plugins/globals.plugin'

Vue.filter('date', function (value) {
  if (value) {
    return getDateString({ date: value })
  }
})
